// extracted by mini-css-extract-plugin
export default {"body":"rNRR02BZI_MivYkoMV3L","td":"Vy5_n3GvRtpOttuPqNX_","footer":"QYt5y7wRmxcOR7LJdnC0","rows":"mIOtkCLQxgnFEwGxrFJm"};